import type { FC, ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

import type { PillVariant } from './pillVariants';
import { pillBackgroundColor, pillColor } from './pillVariants';

import { styles } from './index.styles';

export interface PillProps {
  label: ReactNode;
  icon?: ReactNode;
  color: PillVariant;
  squared?: boolean;
  sx?: object;
}

const Pill: FC<PillProps> = ({ label, icon, color, squared, sx }) => {
  const theme = useTheme();

  return (
    <Typography
      variant="caption"
      color={pillColor(theme, color)}
      bgcolor={pillBackgroundColor(theme, color)}
      sx={(theme) => ({ ...styles.pill(theme), ...sx })}
      borderRadius={squared ? 1 : 5}
    >
      {icon}
      {label}
    </Typography>
  );
};

export default Pill;
